export function formatAmount(value) {
  if (value === null || value === undefined || value === '') return 'N/A';

  const raw = String(value).trim();
  if (!raw) return 'N/A';

  const stripped = raw.replace(/[$,]/g, '').trim();
  const numeric = Number(stripped);
  if (stripped !== '' && Number.isFinite(numeric)) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(numeric);
  }

  return raw;
}
